import { IDirective } from 'angular';

/**
 * Директива limited-feature-dir сохранена как заглушка: в ShbDeployer все функции
 * доступны полностью, поэтому элементы никогда не скрываются и не блокируются.
 */
/* @ngInject */
export function limitedFeatureDirective(): IDirective {
  return {
    restrict: 'A',
    link() {},
  };
}
